import api from './api';
import apiPublic from './apiPublic';

const PUBLIC = '/public';
const ADMIN = '/admin';

export const selectionProcessesPublic = {
  getBySlug: slug => apiPublic.get(`${PUBLIC}/selection_processes/${slug}`).then(r => r.data),

  listRegionals: slug => apiPublic.get(`${PUBLIC}/regionals`, { params: { selection_process_slug: slug } }).then(r => r.data),

  listInstitutions: regionalId => apiPublic.get(`${PUBLIC}/institutions`, { params: { regional_id: regionalId } }).then(r => r.data),

  submitRegistration: (slug, payload) => apiPublic.post(`${PUBLIC}/selection_processes/${slug}/registrations`, { registration: payload }).then(r => r.data)
};

export const selectionProcessesAdmin = {
  list: (params = {}) => api.get(`${ADMIN}/selection_processes`, { params }),
  get: id => api.get(`${ADMIN}/selection_processes/${id}`),
  create: attrs => api.post(`${ADMIN}/selection_processes`, { selection_process: attrs }),
  update: (id, attrs) => api.patch(`${ADMIN}/selection_processes/${id}`, { selection_process: attrs }),
  destroy: id => api.delete(`${ADMIN}/selection_processes/${id}`),
  publish: id => api.post(`${ADMIN}/selection_processes/${id}/publish`),
  close: id => api.post(`${ADMIN}/selection_processes/${id}/close`),
  registrations: (id, params = {}) => api.get(`${ADMIN}/selection_processes/${id}/registrations`, { params }),
  summary: id => api.get(`${ADMIN}/selection_processes/${id}/registrations/summary`),
  exportCsv: (id, params = {}) => api.get(`${ADMIN}/selection_processes/${id}/registrations/export.csv`, { params, responseType: 'blob' }),
  exportXlsx: (id, params = {}) => api.get(`${ADMIN}/selection_processes/${id}/registrations/export.xlsx`, { params, responseType: 'blob' })
};
